import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { Drawer } from '@mui/material';
import IcClose from '../../assets/image/ic_x.svg';
import { useTranslation } from '../../hook/useTranslation';

import { COMMUNITY_TYPE } from '../../data/define';

function WirteModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0' } }}
    >
      <div className="w-full p-[20px] text-[#1C1C1C] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden pb-[40px]">
        <div className="w-full flex justify-between items-center mb-3">
          <div className="w-[24px]" />
          <div className="w-full text-center text-[#1C1C1C] text-[18px] font-[600]">{t('community.write_modal.title')}</div>
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center cursor-pointer"
          >
            <img src={IcClose} alt="Close" />
          </button>
        </div>
        <div className="w-full flex flex-col gap-2 mt-[20px]">
          <button
            type="button"
            className="w-full h-[56px] flex items-center justify-center bg-[#F8F8F8] rounded-[16px] text-[#1C1C1C] text-[16px] font-[600]"
            onClick={() => {
              onClose();
              navigate(`${Url.CommunityWrite}?type=${COMMUNITY_TYPE.FREE_BOARD}`);
            }}
          >
            {t('community.write_modal.freeboard')}
          </button>
          <button
            type="button"
            className="w-full h-[56px] flex items-center justify-center bg-[#F8F8F8] rounded-[16px] text-[#1C1C1C] text-[16px] font-[600]"
            onClick={() => {
              onClose();
              navigate(`${Url.CommunityWrite}?type=${COMMUNITY_TYPE.ANALYSIS}`);
            }}
          >
            {t('community.write_modal.qna')}
          </button>
        </div>
      </div>
    </Drawer>
  );
}

export default WirteModal;
